import ApiService from './api.service';

class ProductService {
  async list() {
    try {
      const response = await ApiService.get('/product');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/product/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/product/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/product/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async exportProductSalesExcel() {
    try {
      const filename = `ventes-produits-${new Date().toISOString().split('T')[0]}.xlsx`;
      await ApiService.downloadFile('/export/product-sales/excel', filename);
    } catch (error) {
      throw error;
    }
  }
}

export default new ProductService(); 